// extracted by mini-css-extract-plugin
module.exports = {"changePassBtn":"General_changePassBtn__uZVAS","userBlock":"General_userBlock__32X_K"};